import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useNonprofitDescriptionLogic } from './hooks/useNonprofitDescriptionLogic';
import { NonprofitDescriptionForm } from './NonprofitDescriptionForm';

export const EddNonprofitDescription = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useNonprofitDescriptionLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        text={t('organic.nonprofitDescription.content')}
        textCustomStyle='text-text-main-primary text-[16px] whitespace-pre-line'
        content={t('organic.nonprofitDescription.title')}>
        <NonprofitDescriptionForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
